var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34783 0.542297C3.50626 2.02305 0 6.36912 0 11.5C0 17.8513 5.37258 23 12 23C18.6274 23 24 17.8513 24 11.5C24 6.36912 20.4937 2.02305 15.6522 0.542297V2.65095C19.4009 4.04703 22 7.52677 22 11.5C22 16.6673 17.6039 21 12 21C6.39608 21 2 16.6673 2 11.5C2 7.52677 4.59906 4.04703 8.34783 2.65095V0.542297Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H13V11H11V0Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffRed);
export default __webpack_public_path__ + "static/media/offRed.55c623a054d50ab634144371ea3330af.svg";
export { ForwardRef as ReactComponent };